import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";

import Template from "./template";

export default class ClientDetailPropertyRoute extends BaseRoute {
  id = "client-detail-case-property-damage";
  ignoreQueryKeys = ["rvClientDetail"];
  revalidateOnParams = [];
  revalidateOnQueryKeys = [];
  revalidateOnQueryAnyChange = false;

  element = (<Template />);

  async loader() {
    return {};
  }

  shouldRevalidate() {
    return false;
  }
}
